import { render, staticRenderFns } from "./show.vue?vue&type=template&id=f7129494&"
import script from "./show.vue?vue&type=script&lang=ts&"
export * from "./show.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports